const state = {
    menu: [
        // { title: '健康信息', path: '/hospitalInfo', icon: 'house-medical'},//1
        { title: '预约挂号', path: '/registered', icon: 'cash-register'},//2
        { title: '就诊查询', icon: 'clipboard-question',//3
            children: [
                {title: '预约查询', path: '/registeredRecord', icon: 'spa'},
                // { title: '就诊记录', path: '/medicalRecord'},
                { title: '处方查询', path: '/prescriptionQuery', icon: 'pills'},
                { title: '费用查询', path: '/costQuery', icon: 'circle-dollar-to-slot'}
        ]},
        { title: '服务', icon: 'map',//4
            children: [
                { title: '网上咨询', path: '/onlineConsulting', icon: 'headset'},
                { title: '网上投诉', path: '/onlineComplaints', icon: 'face-frown'}
        ]},
    ],
    menuLeft: '',
    selectedKeys: [1]//当前选中的菜单 key
}
const mutations = {
    SET_SELECTEDKEYS(state, selectedKeys){
        let index = selectedKeys[0];
        if(typeof(index) == 'string'){
            state.menuLeft = state.menu[index.split('-')[0]-1];
        }else{
            state.menuLeft = null;
        }
        
        state.selectedKeys = selectedKeys;
    }
}
const actions = {
    setSelectedKeys({commit}, selectedKeys){
        commit('SET_SELECTEDKEYS', selectedKeys.values);
    }
}
export default{
    namespaced: true,//用于全局引用此文件里的方法时标识这个文件名，解决命名冲突问题
    state,
    mutations,
    actions
}